import { Reducer } from "redux";

const LOGIN_PAGE_LOCAL_STORAGE_KEY = "freshpaintLoginPage";

export const SET_LOGIN_PAGE = "SET_LOGIN_PAGE";

interface LoginPageState {
  // This is the path to the correct login page for this user. Users of accounts
  // that require logging in via SSO will be redirected to this page when
  // visiting /login.
  loginPage: string;
}

const initialLoginPageState: LoginPageState = {
  loginPage:
    window.localStorage.getItem(LOGIN_PAGE_LOCAL_STORAGE_KEY) || "/login",
};

type SetLoginPageAction = {
  type: typeof SET_LOGIN_PAGE;
  loginPage: string;
};

type LoginPageActions = SetLoginPageAction;

const loginPageReducer: Reducer<LoginPageState, LoginPageActions> = (
  state = initialLoginPageState,
  action,
): LoginPageState => {
  if (action === undefined) {
    return initialLoginPageState;
  }

  switch (action.type) {
    case SET_LOGIN_PAGE:
      window.localStorage.setItem(
        LOGIN_PAGE_LOCAL_STORAGE_KEY,
        action.loginPage,
      );
      return {
        loginPage: action.loginPage,
      };
    // This clause looks redundant, but it's needed for when redux calls this
    // reducer with an initialization action to get the initial state.
    default:
      return state;
  }
};

export default loginPageReducer;
